import { IconName } from '@televet/kibble-ui';
import { SpeciesType } from 'shared/types/graphql';

export const getSpeciesIcon = (speciesType?: SpeciesType, isDeceased?: boolean): IconName => {
  if (isDeceased) return 'ribbon';
  switch(speciesType) {
    case SpeciesType.Canine: {
      return 'animalDog';
    }
    case SpeciesType.Feline: {
      return 'animalCat';
    }
    case SpeciesType.Avian: {
      return 'animalBird';
    }
    case SpeciesType.Equine: {
      return 'animalHorse';
    }
    case SpeciesType.Bovine: {
      return 'animalCow';
    }
    default: {
      return "paw";
    }
  }
};
